<template>
  <Body class="hero is-bold">
    <ModalLoginResetRequest
      :isModalLoginReset="isDuplicateLogin"
      @cancel="cancelLoginReset"
    />
    <div class="hero-body">
      <div class="container" style="max-width:500px;">
        <article class="message is-primary">
          <div class="message-header">
            <p>{{ $t('LoginBody.signin') }}</p>
          </div>
          <div class="message-body" @keyup.enter="inputs.email != null && inputs.password ? login(inputs) : ''" >
            <b-field horizontal :label="$t('LoginBody.email')" style="font-size:12px;" >
                <b-input v-model="inputs.email"
                type="email"
                icon="email"
                >
                </b-input>
            </b-field>
            <b-field horizontal :label="$t('LoginBody.password')" style="font-size:12px;">
                <b-input v-model="inputs.password"
                type="password"
                icon="lock"
                password-reveal></b-input>
            </b-field>
            <b-field>
              <button class="button is-primary" @click="login(inputs)" v-if="!disabled" :disabled="disabled">
                {{ $t('TopNav.signin') }}
              </button>
              <button class="button is-primary" v-if="disabled" :disabled="disabled">
                {{ $t('TopNav.signin') }}
              </button>
            </b-field>
            <b-field>
              <a style="font-size: 13px;" @click="$store.dispatch('auth/setPRModal')">
                パスワードをお忘れの方へ
              </a>
            </b-field>
            <ModalPasswordReset/>
          </div>
        </article>
      </div>
    </div>
  </Body>
</template>

<script>
import Body from '@/components/layouts/Body'
import ModalPasswordReset from '@/components/ui/ModalPasswordReset'
import ModalLoginResetRequest from '@/components/ui/ModalLoginResetRequest'
import { mapState } from 'vuex'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'LoginBody',
  componentName: 'LoginBody',
  components: {
    Body,
    ModalPasswordReset,
    ModalLoginResetRequest,
  },
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      isLoggingIn: false,
      isDuplicateLogin: false,
      inputs: {
        email: '',
        password: '',
      }
    }
  },
  computed: {
    disabled () {
      console.debug('*** Start *** disabled')
      return this.inputs.email === '' || this.inputs.password === '' || this.isLoggingIn
    },
    ...mapState('auth', ['authenticating', 'error', 'token', 'isModalPasswordReset', 'isUser', 'isClient', 'token', 'errorMessage'])
  },
  watch: {
    token () {
      if (this.isClient) {
        this.sendControlLog('ログイン', 'メールアドレスとパスワードが認証され、ログインした。')
        this.$router.push('/dashboard')
      }
      else if (this.isUser) location.href= process.env.WDT_ENDPOINT + '/recruit/'
    }
  },
  methods: {
    // login
    login ({ email, password }) {
      this.isLoggingIn = true
      this.$store.dispatch('auth/login', { email, password })
        .then(() => {
          if (this.error) {
            // indexOfで文字列が見つからない場合は-1が返るので、見つからないケースは除外する。
            if (this.errorMessage.indexOf('既にログイン中です') != -1) {
              const isConfirm = confirm(this.errorMessage + '\nログイン状態をリセットしますか？')
              if (isConfirm) {
                this.isDuplicateLogin = true
              }
            } else {
              this.errorBar(this.errorMessage)
            }
          }
        })
        .finally(() => {
          this.isLoggingIn = false
        })
    },
    errorBar (e) {
      this.$buefy.snackbar.open({
        message: e.replace(/'|"/g, ''),
        type: 'is-danger',
        position: 'is-top'
      })
    },
    cancelLoginReset () {
      this.isDuplicateLogin = false
    }
  }
}
</script>

<style scoped>
p {
  font-weight: bold;
  font-size: 1.4em;
}
</style>



// WEBPACK FOOTER //
// src/views/Login/LoginBody.vue